<template>
  <el-row :gutter="10">
    <el-col
      :xl="{ span: 5 }"
      :lg="{ span: 5 }"
      :md="{ span: 5 }"
      :sm="{ span: 12 }"
      :xs="{ span: 12 }"
    >
      <div class="time">{{ now }}</div>
    </el-col>
    <el-col
      :xl="{ span: 15 }"
      :lg="{ span: 15 }"
      :md="{ span: 15 }"
      :sm="{ span: 10, offset: 1 }"
      :xs="{ span: 10, offset: 1 }"
    >
      <el-menu
        class="menu hidden-sm-and-down"
        default-active="/index"
        router
        mode="horizontal"
        @select="handleSelect"
        text-color="#fff"
        active-text-color="white"
        close="top-menu"
      >
        <el-menu-item index="/index" class="navigation_bar_item"
          >首页</el-menu-item
        >

        <el-menu-item index="/introduction" class="navigation_bar_item"
          >期刊简介</el-menu-item
        >
        <el-menu-item index="/guidelines" class="navigation_bar_item"
          >投稿指南</el-menu-item
        >
        <el-menu-item index="/forum" class="navigation_bar_item"
          >云上论坛报告</el-menu-item
        >
        <el-menu-item index="/star" class="navigation_bar_item"
          >语言实验之星</el-menu-item
        >
        <el-menu-item index="/software" class="navigation_bar_item"
          >实验软件</el-menu-item
        >
        <el-menu-item index="/training" class="navigation_bar_item"
          >网上研修班</el-menu-item
        >
      </el-menu>
      <el-menu
        class="hidden-md-and-up"
        background-color="#006a71"
        text-color="#fff"
        active-text-color="#ff8041"
        style="z-index: 1"
        router
      >
        <el-submenu>
          <template slot="title">
            <span style="color: white; font-size: 22px; font-weight: 100"
              >导航</span
            ></template
          >
          <el-menu-item index="1" class="sub_menu_item" route="index"
            >首页</el-menu-item
          >
          <el-menu-item index="2" class="sub_menu_item" route="introduction"
            >期刊简介</el-menu-item
          >
          <el-menu-item index="3" class="sub_menu_item" route="guidelines"
            >投稿指南</el-menu-item
          >
          <el-menu-item index="4" class="sub_menu_item" route="/forum"
            >云上论坛报告</el-menu-item
          >
          <el-menu-item index="5" class="sub_menu_item" route="/star"
            >语言实验之星</el-menu-item
          >
          <el-menu-item index="6" class="sub_menu_item" route="/software"
            >实验软件</el-menu-item
          >
          <el-menu-item index="/training" class="sub_menu_item"
            >网上研修班</el-menu-item
          >
        </el-submenu>
      </el-menu>
    </el-col>
    <el-col
      :xl="{ span: 1, offset: 1 }"
      :lg="{ span: 1, offset: 1 }"
      :md="{ span: 1, offset: 1 }"
      :sm="{ span: 1, }"
      :xs="{ span: 1,  }"
    >
      <div class="block" v-if="userInfo != null">
        <el-dropdown>
          <el-avatar
            :size="50"
            src="../../static/materials/user.gif"
            class="el-dropdown-link"
          ></el-avatar>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>消息中心</el-dropdown-item>
            <el-dropdown-item
              ><span @click="logout()"> 退出登录 </span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div v-else>
        <el-dropdown>
          <el-avatar
            :size="50"
            src="../../static/materials/user.gif"
            class="el-dropdown-link"
          ></el-avatar>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>消息中心</el-dropdown-item>
            <el-dropdown-item
              ><span @click="logout()"> 退出登录 </span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-col>
  </el-row>
</template>

<script>
module.exports = {
  name: 'NavigationBarComponent',
  data () {
    return {
      now: null,
      userInfo: null

    }
  },
  methods: {
    getNowDate () {
      const timeOne = new Date()
      const year = timeOne.getFullYear()
      let month = timeOne.getMonth() + 1
      let day = timeOne.getDate()
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      const NOW_MONTHS_AGO = `${year}年${month}月${day}日`
      return NOW_MONTHS_AGO
    },

    init () {
      this.now = this.getNowDate()
    },

    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    },
    logout () {
      this.$cookie.removeCookie('userInfo')
      this.$cookie.removeCookie('authority')
      this.userInfo = null
      this.$router.go(0)
    }
  },
  mounted () {
    this.init()
    let userInfo = this.$cookie.getCookie('userInfo')
    if (userInfo == null) {
      this.$message({
        message: '如有提交稿件、审核稿件等需求，请先登录！',
        type: 'error'
      })
      this.$router.push('index')
    }
    this.userInfo = userInfo
  }
}
</script>

<style scoped>
.is-disabled {
  opacity: 1;
  color: white !important;
  font-weight: 500;
}
.is-active {
  background-color: #ff8041;
  /* background-image: linear-gradient(#ff8041, #ff8041, #ff8041); */
  color: white;
  font-size: 14px;
  font-weight: 900;
  height: 55px;
  line-height: 55px;
}

.el-menu-item {
  font-size: 14px;
  height: 60px;
}
/* .sub_menu_item {
  color: white;
  font-size: 14px;
  font-weight: 900;
  width: 20%;
} */

.navigation_bar {
  color: aliceblue;
  background-image: linear-gradient(#006a71, #005152, #002412);
}

.el-menu-item.navigation_bar_item:hover {
  background-color: #ff8041;
}

.el-submenu .el-menu-item {
  height: 50px;
  line-height: 50px;
  padding: 0 !important;
  min-width: 0 !important;
}
.menu {
  height: 60px;
  line-height: 60px;
  background-image: linear-gradient(#006a71, #005152, #002412);
}
.time {
  width: 220px;
  font-size: 22px;
  color: #fff;
  height: 55px;
  line-height: 55px;
}

.navigation_bar_item {
  width: 14.2%;
}

.footer_item {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/navigationBarComponent.vue